import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

function remainingMs(end) {
  const raw = end.length <= 10 ? end + "T23:59:59" : end;
  return new Date(raw).getTime() - Date.now();
}

export default function PromoCountdown({ end, compact = false }) {
  const [ms, setMs] = useState(() => remainingMs(end));
  useEffect(() => {
    setMs(remainingMs(end));
    const id = setInterval(() => setMs(remainingMs(end)), 1000);
    return () => clearInterval(id);
  }, [end]);

  if (ms <= 0 || isNaN(ms)) return null;
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const label = d > 0 ? `${d}j ${h}h ${m}m` : `${h}h ${m}m ${sec}s`;

  if (compact)
    return (
      <span className="inline-flex items-center gap-1 text-[10px] font-bold text-[#DC2626]" data-testid="promo-countdown">
        <Clock className="w-3 h-3" /> {label}
      </span>
    );
  return (
    <div className="inline-flex items-center gap-1.5 bg-red-50 text-[#DC2626] font-bold text-sm px-3 py-1.5 rounded-lg" data-testid="promo-countdown">
      <Clock className="w-4 h-4" /> Fin de la promo dans {label}
    </div>
  );
}
